import React from 'react';
import { NeuroMessage } from "@ignitesales/neuro-application";
import classnames from "classnames";
import { ActionService } from '../services/ActionService.mjs';

const ActionButton = ({ className, action, position }) => {
    const componentClass = "action-button";
    const classes = classnames('button', "btn", "btn-outline-secondary", componentClass, className);
    const trigger = ActionService.extractButtonTriggerByPosition(action, position);
    const messageId = `${trigger?._id}.button`;

    const actionClicked = async (trigger) => {
        await ActionService.triggerAction(action, trigger?._id, await ActionService.extractActionParams(action));
        //TODO: handle UI events and show success and error message UI
    }

    return <div className="action-button-wrapper">
        <button className={classes} onClick={() => actionClicked(trigger)}>
            <NeuroMessage id={messageId} tagName="span"/>
        </button>
    </div>
};

export default ActionButton;
